import React from "react";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as _ from "lodash";
import colors from "../../../utils/colors";
import Text from "./Text";
import theme from "../../theme";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
	root: {
		background: colors.inputBackground,
		padding: "10px 15px",
		height: "fit-content",
		minHeight: "140px",
		[theme.breakpoints.down('sm')]: {
			padding: "5px 10px"
		}
	}
});

type CustomContent = {
	type: string;
	value: string;
	classes?: any;
};

interface TextProps {
	contentArr: CustomContent[];
}

const StepInstruction = ({ contentArr }: TextProps) => {
	const classes = useStyles();
	const { t } = useTranslation("common");

	return (
		<Grid
			container
			item
			direction="column"
			alignItems="center"
			className={classes.root}
		>
			{_.map(contentArr, (item, key) => (
				<Text
					key={key}
					type={item.type}
					value={t(item.value)}
					customClasses={item.classes}
				/>
			))}
		</Grid>
	);
};

export default StepInstruction;
